import { createSelector } from '@reduxjs/toolkit';

import { selectAppConfig } from '@/features/config/selectAppConfig';
import { selectLocale } from '@/features/i18n/selectLocale';

export const selectTelegramChannel = createSelector(
  [selectAppConfig, selectLocale],
  ({ telegramChannelMapping }, locale) => (locale ? telegramChannelMapping[locale] : null),
);
